module.exports = __webpack_public_path__ + "static/img/leleren.b2eb131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leleren.jpg
// module id = RrPy
// module chunks = 1